import { render, staticRenderFns } from "./TripBill.vue?vue&type=template&id=f82f9f4c&scoped=true&"
import script from "./TripBill.vue?vue&type=script&lang=js&"
export * from "./TripBill.vue?vue&type=script&lang=js&"
import style0 from "./TripBill.vue?vue&type=style&index=0&id=f82f9f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82f9f4c",
  null
  
)

export default component.exports